// This import loads the firebase namespace along with all its type information.
import MetricDeploymentConfig from './metric-deployment-config-model'

export async function load_metricDeploymentConfigs(): Promise<
  MetricDeploymentConfig[]
> {
  throw 'Not implemented'
}

export async function delete_metricDeploymentConfig(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_metricDeploymentConfig(): Promise<MetricDeploymentConfig> {
  throw 'Not implemented'
}
